// redux/member-slices/specialist.slice.js
import { asyncThunkWrapper } from "../thunkHandler";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BASEURI, headers } from "../../utils/helper";

// Retrieve all specialists
export const handleRetrieveAllSpecialists = createAsyncThunk(
    "retrieveAll",
    async (data, thunkAPI) => {
        const params = {
            limit: data?.limit || 10,
            currentPage: data?.currentPage || 1,
            country: data?.country,
            preferredConnectTime: data?.preferredConnectTime,
            preferredLanguage: data?.preferredLanguage,
            timezone: data?.timezone,
            specializationIds: data?.specializationIds || [],
        };



        return asyncThunkWrapper(
            {
                url: `${BASEURI}/public/quetsionare/specialist/retrieve-all`,
                method: "GET",
                headers: headers(),
                params: params,
            },
            thunkAPI,
            {
                toast: false,
            }
        );
    }
);

export const handleRetrieveAllBlogs = createAsyncThunk(
    "retrieveAll",
    async (data, thunkAPI) => {
        const params = {
            limit: data?.limit || 10,
            currentPage: data?.currentPage || 1,
            specializationIds: data?.specializationIds || [],
        };



        return asyncThunkWrapper(
            {
                url: `${BASEURI}/public/quetsionare/blogs/retrieve-all`,
                method: "GET",
                headers: headers(),
                params: params,
            },
            thunkAPI,
            {
                toast: false,
            }
        );
    }
);